import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_4bfffd30 from 'nuxt_plugin_plugin_4bfffd30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_f9285684 from 'nuxt_plugin_plugin_f9285684' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_7590cc3f from 'nuxt_plugin_vuesocialsharingplugin_7590cc3f' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_0b5cc3ee from 'nuxt_plugin_cookieuniversalnuxt_0b5cc3ee' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_image_7c51257e from 'nuxt_plugin_image_7c51257e' // Source: ./image.js (mode: 'all')
import nuxt_plugin_pluginutils_69c7d2b5 from 'nuxt_plugin_pluginutils_69c7d2b5' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_65c2f280 from 'nuxt_plugin_pluginrouting_65c2f280' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_6515dcaf from 'nuxt_plugin_pluginmain_6515dcaf' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_toast_b9fe8616 from 'nuxt_plugin_toast_b9fe8616' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_axios_525f1f74 from 'nuxt_plugin_axios_525f1f74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_swiper_419e176c from 'nuxt_plugin_swiper_419e176c' // Source: ../plugins/swiper (mode: 'client')
import nuxt_plugin_lazyhydrate_5fe36607 from 'nuxt_plugin_lazyhydrate_5fe36607' // Source: ../plugins/lazy-hydrate.js (mode: 'all')
import nuxt_plugin_ocruntime_5c28a102 from 'nuxt_plugin_ocruntime_5c28a102' // Source: ../plugins/oc-runtime.js (mode: 'client')
import nuxt_plugin_attachtoken_4ac02db0 from 'nuxt_plugin_attachtoken_4ac02db0' // Source: ../plugins/attach-token.js (mode: 'client')
import nuxt_plugin_auth_6dc1182a from 'nuxt_plugin_auth_6dc1182a' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s - Tajadad","title":"Tajadad","htmlAttrs":{"lang":"ar"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"property":"og:site_name","content":"Tajadad"},{"property":"og:image:width","content":"740"},{"property":"og:image:height","content":"300"},{"name":"twitter:site","content":"@Tajadad"},{"name":"twitter:card","content":"summary_large_image"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"theme-color","content":"#ffffff"},{"http-equiv":"pragma","content":"no-cache"},{"http-equiv":"cache-control","content":"no-cache"},{"http-equiv":"expires","content":"0"}],"noscript":[{"innerHTML":"Scripts are not supported","body":true}],"link":[{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#05437a"},{"rel":"manifest","href":"\u002Fsite.webmanifest"},{"rel":"dns-prefetch","href":"https:\u002F\u002Ftajadad.app\u002F"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_4bfffd30 === 'function') {
    await nuxt_plugin_plugin_4bfffd30(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_f9285684 === 'function') {
    await nuxt_plugin_plugin_f9285684(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_7590cc3f === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_7590cc3f(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_0b5cc3ee === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_0b5cc3ee(app.context, inject)
  }

  if (typeof nuxt_plugin_image_7c51257e === 'function') {
    await nuxt_plugin_image_7c51257e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_69c7d2b5 === 'function') {
    await nuxt_plugin_pluginutils_69c7d2b5(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_65c2f280 === 'function') {
    await nuxt_plugin_pluginrouting_65c2f280(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_6515dcaf === 'function') {
    await nuxt_plugin_pluginmain_6515dcaf(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_b9fe8616 === 'function') {
    await nuxt_plugin_toast_b9fe8616(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_525f1f74 === 'function') {
    await nuxt_plugin_axios_525f1f74(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiper_419e176c === 'function') {
    await nuxt_plugin_swiper_419e176c(app.context, inject)
  }

  if (typeof nuxt_plugin_lazyhydrate_5fe36607 === 'function') {
    await nuxt_plugin_lazyhydrate_5fe36607(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ocruntime_5c28a102 === 'function') {
    await nuxt_plugin_ocruntime_5c28a102(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_attachtoken_4ac02db0 === 'function') {
    await nuxt_plugin_attachtoken_4ac02db0(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_6dc1182a === 'function') {
    await nuxt_plugin_auth_6dc1182a(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
